'use client';

import { useEffect } from 'react';
import {
    Heading,
    TextPassage,
    Alert,
    AlertBody,
    LayoutLinelengthContainer,
} from '@petsmart-ui/sparky';
import { COMPONENTS, logConsoleError } from '@libs/common-next';
import type { Errors } from '@app/pdp/components/AddToCart/DeliveryMethods/types';

type ErrorMessageProps = {
    errorType: Errors;
};

const errorMessages = {
    estimationValidation: {
        title: 'Not available in your area',
        description: 'Please select another fulfillment method',
    },
    emptyFields: {
        title: 'Information missing',
        description: 'Please review errors for missing information',
    },
    invalidFields: {
        title: 'Invalid entry',
        description: 'Please review the errors below',
    },
};

const verifyErrorMessage = (errorType: Errors) => errorMessages[errorType];

export default function ErrorMessage({
    errorType,
}: Readonly<ErrorMessageProps>) {
    const { title, description } = verifyErrorMessage(errorType);

    useEffect(() => {
        if (title === errorMessages.estimationValidation.title) {
            logConsoleError(title, {
                component: COMPONENTS.SDD_PDP_DRAWER_ALERT,
                severity: 'HIGH',
                additionalInfo: description,
            });
        }
    }, [title, description]);

    return (
        <Alert variant="error" iconName="exclamation-circle-fill">
            <AlertBody>
                <LayoutLinelengthContainer>
                    <Heading size="body-bold" tagName="h2">
                        {title}
                    </Heading>
                </LayoutLinelengthContainer>
                <TextPassage>
                    <p>{description}</p>
                </TextPassage>
            </AlertBody>
        </Alert>
    );
}
